import React, { ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import HomeNav from '../components/navbar/HomeNav';
import HomeFooter from '../components/footer/HomeFooter';

interface CreateLayoutProps {
    children: ReactNode;
}

const Layout: React.FC<CreateLayoutProps> = ({ children }) => {

    const [shownavbar, setShowNavbar] = useState(true);

    const location = useLocation();
    const { hash, pathname, search } = location;
  
    useEffect(() => {
      function handleResize() {
        if(pathname==="/profile" || pathname==="/edit-profile"){
        setShowNavbar(window.innerWidth >= 767);
        }
        else{
            setShowNavbar(true);
        }
      }
      window.addEventListener('resize', handleResize);
      handleResize();
      return () => window.removeEventListener('resize', handleResize);
    }, [location]);
  
    return (
        <div className=' mx-auto '>
              {shownavbar &&
                <HomeNav />}
            <div className='py-[95px] overflow-x-hidden min-h-[calc(100vh_-_95px)]'>
                {children}
            </div>
            <HomeFooter/>
        </div>
    );
};

export default Layout;
